import { Injectable } from '@angular/core'

import { ResourceGroup } from '@mprep/shared/data/models'
import { ModelRepository, ModelRepositoryAdapter } from '@mprep/shared'
import { Observable } from 'rxjs';

@Injectable()
export class ResourceGroupService extends ModelRepositoryAdapter<ResourceGroup> {

  constructor(
    _modelRepository: ModelRepository
  ) {
    super(_modelRepository, ResourceGroup)
  }

  public findResources(resourceTypeId: number): Observable<any> {
    return this.findModelsBy(
      { 'resourceTypeId': resourceTypeId },
      ['resources']
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/resource-group/resource-group.service.ts